import React from 'react';
import SubNavigationItem from './SubNavigationItem';
var SubNavigationItems = function SubNavigationItems(_ref) {
  var disableDropdown = _ref.disableDropdown,
    items = _ref.items,
    className = _ref.className,
    _ref$linkClassName = _ref.linkClassName,
    linkClassName = _ref$linkClassName === void 0 ? 'nav-link p-0 px-1' : _ref$linkClassName,
    _ref$listItemClassNam = _ref.listItemClassName,
    listItemClassName = _ref$listItemClassNam === void 0 ? 'mx-2 nav-item' : _ref$listItemClassNam,
    onLinkClick = _ref.onLinkClick,
    ChildComponentRenderer = _ref.childComponentRenderer;
  return /*#__PURE__*/React.createElement("ul", {
    className: className
  }, items.map(function (item) {
    return /*#__PURE__*/React.createElement(SubNavigationItem, {
      disableDropdown: disableDropdown,
      item: item,
      key: item.name,
      linkClassName: linkClassName,
      listItemClassName: listItemClassName,
      onLinkClick: onLinkClick,
      childComponent: function childComponent(_ref2) {
        var onLinkClick = _ref2.onLinkClick,
          childItems = _ref2.childItems;
        return /*#__PURE__*/React.createElement(ChildComponentRenderer, {
          className: "dropdown-menu show py-0 rounded-0 mt-1",
          items: childItems,
          listItemClassName: "border-top",
          linkClassName: "dropdown-item",
          onLinkClick: onLinkClick
        });
      }
    });
  }));
};
export default SubNavigationItems;